import { Classes } from '@blueprintjs/core';
import { useTranslation } from '@web_opxp/features';
import { TSubscriptionStatus } from '../types';
import './SubscriptionStatusBadge.scss';

interface ISubscriptionStatusBadgeProps {
  status: TSubscriptionStatus;
}

export default function SubscriptionStatusBadge({ status }: Readonly<ISubscriptionStatusBadgeProps>) {
  const { t } = useTranslation();

  return (
    <div className="row subscription-status">
      <div className="col-3 col-m-2">
        <p className="label">{t('manage:Manage.Subscription.Status.Title')}</p>
      </div>
      <div className="col-9 col-m-2">
        <small className={`${Classes.TAG} status ${status}`}>{t(`manage:Manage.Subscription.Status.${status}`)}</small>
      </div>
    </div>
  );
}
